import React from 'react';
import './footer.css';
import image from '../../assets/footer-image.svg';
import illustration from '../../assets/footer-illustration.svg';
import { Link } from 'react-router-dom';
import logo from '../../assets/c3-logo.png';


function Footer() {
    return (
        <div   className="footer__main">
        
            <div className="footer__link">
                <div className="footer__linksTop">
                    <div className="footer__linksTopLeft">
                        <div className="head__two">
                           <img src={logo} alt="" srcset="" />
                        </div>
                        <div className="footer__text">
                        Find your dream course here
                        </div>
                        <div className="footer__image">
                            <img src={image} alt="" />
                        </div>
                    </div>
                    <div className="footer__linksTopMid">
                        <div className="tagline__head">
                            Links
                        </div>
                        <div className="footer__links">
                            <Link to='/'>Home</Link>
                            <Link to='/about'>About Us</Link>
                            <Link to='/course'>Courses</Link>
                        </div>
                    </div>
                    <div className="footer__linksTopRight">
                    <div className="tagline__head">
                         Other Links
                    </div>
                        <div className="footer__links">
                            <Link to='/contact'>Contact Us</Link>
                            <Link to='/faq'>FAQ's</Link>
                            {/* <Link to='/'>Terms and Conditions</Link> */}
                        </div>
                    </div>
                </div>
                <div className="footer__copyright">
                2021 Charis Coding Club. Allright reserved
                </div>
            </div>
        </div>
    )
}

export default Footer
